import { useEffect } from "react";
import "./Checkout.css";
import SubtotalWithoutLogin from "./SubtotalWithoutLogin";
import { useStateValue } from "./StateProvider";
import CheckoutProduct from "./CheckoutProduct";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  createTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";

const theme = createTheme({
  typography: {
    h1: { fontSize: "0.5rem" },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 425,
      md: 768,
      lg: 1024,
      xl: 1280,
      "2xl": 1536,
      "3xl": 1920,
      "4xl": 2560,
      "5xl": 3200,
    },
  },
});

function Checkout({ deliveryAddressDocPath }) {
  const [{ basket, user }, dispatch] = useStateValue();
  const navigate = useNavigate();
  useEffect(() => {
    if (basket.length === 0) {
      navigate("/Home");
      return;
    }
  }, [basket]);
  return (
    <ThemeProvider
      theme={responsiveFontSizes(theme, {
        breakpoints: ["xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl", "5xl"],
        factor: 1,
      })}
    >
      <Grid item xs={12} className="checkout">
        <Grid item xs={6} lg={6} mt={20}>
          <Grid item xs={6} lg={6}>
            <Box>
              <SubtotalWithoutLogin />
            </Box>
          </Grid>
          <Box>
            {basket.map((item) => (
              <CheckoutProduct
                key={item.id}
                id={item.id}
                title={item.title}
                image1_url={item.image1_url}
                price={item.price}
                rating={item.rating}
                ratings={item.ratings}
              />
            ))}
          </Box>
          <Grid item xs={6} lg={6}>
            <Box maxWidth={700}>
              <SubtotalWithoutLogin />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
export default Checkout;
